export default __webpack_public_path__ + "3b0574954112f28a7b4954d5eccf9cdd.svg";